// PATH: src/components/IDE/ide/core/types.ts

import { HelpConfig } from "../helpCode/types";

/** L'IDE ne connaît pas les méthodes du bridge : il est opaque */
export type LanguageId = 'javascript' | 'python';

/** Bridge opaque : objet quelconque injecté par l'hôte (Phaser, autre, etc.) */
export type EngineBridge = Record<string, any>;

export interface Breakpoint {
    line: number; // 1-based
}

export interface BreakpointAPI {
    getAll(): Breakpoint[];
    has(line1based: number): boolean;
    toggle(line1based: number): void;
    clear(): void;
}

export interface Controls {
    isPaused: () => boolean;
    requestPause: () => void;
    shouldStop: () => boolean;
    ignoreBreakpoints: () => boolean;
    breakpoints: BreakpointAPI;
}

export interface Executable {
    lang: LanguageId;
    payload: any; // VM state/compiled code, etc.
}

export type RunState = 'idle' | 'running' | 'paused' | 'stopped' | 'error';

export interface LanguageAdapter {
    id: LanguageId;
    editorExtensions(): any[];
    compile(code: string, bridge: EngineBridge, controls: Controls): Promise<Executable>;
    runStep(exec: Executable, controls: Controls): Promise<void>;
    runAll(exec: Executable, controls: Controls): Promise<void>;
    stop?(exec: Executable): Promise<void>;
    registerEventSyntax?(code: string): Record<string, any>;
}

export interface IDEConfig {
    // Code initial affiché dans l'éditeur
    initialCode: string;
    // Code initial pour la vue enseignant
    teacherCode?: string;
    // regrouper help par catégorie
    helpGrouped: boolean;
    // Configuration de l'aide (catégories et snippets)
    helpConfig: HelpConfig;
}

export function getIDEConfigDefault(): IDEConfig {
    return {
        initialCode: '',
        teacherCode: '',
        helpGrouped: false,
        helpConfig: {
            activeCategories: [],
            activeSnippets: {}
        },
    };
}
